<template>
	<div class="modal-box" ref="modal">
		<div class="modal-content">
			<header>
				<div class="modal-btn-close">
					<button @click="onClickClose"><shape src="/static/svg/buttons/back.svg"/></button>
				</div>
				<div class="modal-headers">
					<div v-if="subHeader" class="modal-sub-header">{{ subHeader }}</div>
					<div class="modal-header">{{ header }}</div>
				</div>
				<div class="modal-btn-group">
					<slot name="buttons"></slot>
				</div>
			</header>
			<main>
				<slot></slot>
			</main>
			<footer v-if="hasFooterSlot">
				<slot name="footer"></slot>
			</footer>
		</div>
	</div>
</template>

<script>
export default {
	inject: ['$validator'],
	props: [
		'header',
		'subHeader'
	],
	computed: {
		hasDefaultSlot () {
			return !!this.$slots.default
		},
		hasFooterSlot () {
			return !!this.$slots['footer']
		}
	},
	methods: {
		onClickClose () {
			this.$emit('close')
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/modals/ModalBox.vue